import React, { useEffect, useRef, useState } from "react";
import { ReactComponent as CtfIcon } from "../../icons/file-ctf.svg";
import classNames from "classnames";
import { Editable, H6, Icon } from "@alternative/components";
import { IconNames } from "@alternative/icons";
import { Draggable } from "react-beautiful-dnd";

const FILE_NODE = "at-file-node";
const FILE_NODE_DRAG_HANDLE = `${FILE_NODE}__drag-handle`;
const EditableInput = (props) => {
  const { defaultValue, isEditable, onSubmit, ...otherprops } = props;
  const [value, setValue] = useState(defaultValue);
  useEffect(() => {
    setValue(defaultValue);
  }, [defaultValue]);
  const ref = useRef();
  const text = <H6>{value}</H6>;
  return (
    <Editable disabled={!isEditable} childRef={ref} {...otherprops} text={text} type="input">
      <input
        ref={ref}
        type="text"
        value={value}
        onFocus={(e) => e.target.select}
        onChange={(e) => {
          setValue(e.target.value);
        }}
        onKeyDown={(e) => {
          if (!onSubmit) return;
          if (e.key === "Enter") {
            onSubmit(value);
          }
        }}
        onBlur={() => {
          if (!onSubmit) return;
          onSubmit(value);
        }}
      />
    </Editable>
  );
};

export const FileNode = (props) => {
  const { isSelected, file, dragHandleProps, handleChangeName, onClick, isEditable = true } = props;
  const { name } = file;

  return (
    <div onClick={onClick} className={classNames(FILE_NODE, { [`${FILE_NODE}--active`]: isSelected })}>
      {dragHandleProps && <Icon icon={IconNames.DRAG_HANDLE} {...dragHandleProps} className={FILE_NODE_DRAG_HANDLE} />}
      <span className="at-icon">
        <CtfIcon />
      </span>
      <EditableInput
        isEditable={isEditable}
        className={`${FILE_NODE}__des-name`}
        showIcon={false}
        defaultValue={name}
        onSubmit={handleChangeName}
      />
    </div>
  );
};

export const DraggableFileNode = (props) => {
  const { file, index, isSelected, onClick, contextMenuItems, handleChangeName } = props;
  const { id } = file;
  return (
    <Draggable draggableId={id} index={index}>
      {(provided) => (
        <div ref={provided.innerRef} {...provided.draggableProps} onClick={onClick}>
          <FileNode
            isSelected={isSelected}
            file={file}
            dragHandleProps={provided.dragHandleProps}
            contextMenuItems={contextMenuItems}
            handleChangeName={handleChangeName}
          />
        </div>
      )}
    </Draggable>
  );
};
export default FileNode;
